import { useQuery } from '@tanstack/react-query'
import {
  fetchElitePrimePricingDetails,
  selectElitePrimePricingDetails
} from '../../../repository/misc'

async function fetchPricingDetailsOrThrow(): Promise<{ data?: unknown }> {
  const response = await fetchElitePrimePricingDetails()
  // Backend can return 2xx with an error envelope — surface it as a query error so the sheet shows its error state
  if (!selectElitePrimePricingDetails(response)) {
    throw new Error('Invalid elite prime pricing details response')
  }
  return response
}

export function useElitePrimePricingDetails(open: boolean) {
  return useQuery({
    queryKey: ['ELITE_PRIME_PRICING_DETAILS'],
    queryFn: fetchPricingDetailsOrThrow,
    select: selectElitePrimePricingDetails,
    enabled: open,
    retry: 1,
    refetchOnWindowFocus: false
  })
}
